export default __webpack_public_path__ + "static/media/orignal toyo.b5283ee0.png";